export default {
  state: {
    menuList: []
  },
  getters: {
    getMenuList: state => {
      return state.menuList
    },
    findById: state => {
      return function (subId) {
        let res = {}
        if (!subId) return res
        for (let item of state.menuList) {
          res = item.openApiList.find(i => parseInt(i.id) === parseInt(subId))
          if (res) {
            break
          }
        }
        return res
      }
    }
  },
  mutations: {
    async setMenuList (state, res) {
      state.menuList = res
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/apiMenu.js